import LocationImageUploader from '../../2compounds/LocationImageUploader/LocationImageUploader'
import SaveConfirmationModal from '../../2compounds/SaveConfirmationModal/SaveConfirmationModal'
import { texts } from '../../../consts/Texts'
import { Text } from '../../1elements'
import styled from '@emotion/styled'
import uploadIcon from '../../1elements/Icons/svg/upload.svg'
import { useState } from 'react'
import ApiService from '../../../common/ApiCalls'
import { useNavigate } from 'react-router-dom'

const DIV = styled.div(props => ({
  ...props.className,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  height: 300,
  '.sub-heading': {
    margin: '20px 0 10px'
  }
}))

const UploadLocationImageModal = ({
  onEditMode,
  setOnEditMode,
  id,
  tabName,
  imageUrlArray,
  pic,
  Num
}) => {
  const navigate = useNavigate()
  const [imageFile, setImageFile] = useState(null)
  const [, setIsLoading] = useState(false)
  const [counter, setCounter] = useState(0)

  const cancelHandler = () => {
    setOnEditMode(false)
    setImageFile(null)
  }

  // TODO Save handler
  const saveHandler = async e => {
    if (imageFile) {
      e.preventDefault()
      setOnEditMode(false)
      const selectedphoto = imageUrlArray[Num]
      await ApiService().updateLocationImage(
        imageFile,
        id,
        tabName,
        selectedphoto
      )
      setIsLoading(true)
      if (counter < 1) {
        setCounter(counter + 1)
        const selectedPhoto = imageUrlArray[Num]
        await ApiService().updateLocationImage(
          imageFile,
          id,
          tabName,
          selectedPhoto
        )
        setIsLoading(false)
        setOnEditMode(false)
        console.log(counter)
        navigate(0)
      }
    } else {
      setImageFile(null)
    }
  }

  const props = {
    open: onEditMode,
    setOpen: setOnEditMode,
    imageFile,
    heading: texts.imageUploader.heading,
    icon: uploadIcon,
    saveHandler,
    cancelHandler,
    id,
    tabName,
    imageUrlArray,
    Num
  }

  return (
    <SaveConfirmationModal {...props}>
      <DIV>
        <Text className={'sub-heading'}>{texts.imageUploader.subHeading}</Text>
        <LocationImageUploader
          imageFile={imageFile}
          setImageFile={setImageFile}
        />
      </DIV>
    </SaveConfirmationModal>
  )
}

export default UploadLocationImageModal
